module.exports = __webpack_public_path__ + "img/ico_b2b_1.c7a1ee0e.png";